export default function Footer() {
  const scrollToContact = () => {
    const contactSection = document.getElementById('contacto');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-primary text-white py-16 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-10 h-10 flex items-center justify-center">
                <i className="ri-compass-3-line text-3xl text-accent"></i>
              </div>
              <div>
                <div className="font-bold text-xl">RUMBO</div>
                <div className="text-xs text-accent font-medium tracking-wider">
                  MARKETING
                </div>
              </div>
            </div>
            <p className="text-white/80 text-sm leading-relaxed">
              Donde tu marca encuentra su dirección
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h3 className="font-bold text-lg mb-4 text-accent">Navegación</h3>
            <ul className="space-y-2">
              <li>
                <a
                  href="#servicios"
                  className="text-white/80 hover:text-accent transition-colors text-sm cursor-pointer"
                >
                  Servicios
                </a>
              </li>
              <li>
                <a
                  href="#proceso"
                  className="text-white/80 hover:text-accent transition-colors text-sm cursor-pointer"
                >
                  Cómo trabajamos
                </a>
              </li>
              <li>
                <a
                  href="#fundadora"
                  className="text-white/80 hover:text-accent transition-colors text-sm cursor-pointer"
                >
                  Sobre nosotros
                </a>
              </li>
              <li>
                <a
                  href="#contacto"
                  className="text-white/80 hover:text-accent transition-colors text-sm cursor-pointer"
                >
                  Contacto
                </a>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="font-bold text-lg mb-4 text-accent">Servicios</h3>
            <ul className="space-y-2">
              <li className="text-white/80 text-sm">Publicidad Digital</li>
              <li className="text-white/80 text-sm">Creación de Contenido</li>
              <li className="text-white/80 text-sm">Campañas Exclusivas</li>
              <li className="text-white/80 text-sm">Capacitaciones de Venta</li>
              <li className="text-white/80 text-sm">Mailing y Automatizaciones</li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-bold text-lg mb-4 text-accent">Contacto</h3>
            <button
              onClick={scrollToContact}
              className="bg-accent hover:bg-accent-dark text-white px-6 py-2.5 rounded-lg text-sm font-medium transition-all mb-4 whitespace-nowrap cursor-pointer w-full"
            >
              Coordinar reunión
            </button>
            <div className="flex gap-4">
              <a
                href="https://www.linkedin.com/company/rumbomktg/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 hover:bg-accent rounded-lg flex items-center justify-center transition-all cursor-pointer"
                aria-label="LinkedIn"
              >
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
              <a
                href="https://www.instagram.com/rumbomarketing_?igsh=MTFqNjExdHRxYjBkdQ%3D%3D&utm_source=qr"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 hover:bg-accent rounded-lg flex items-center justify-center transition-all cursor-pointer"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-xl"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/60 text-sm">
            © 2024 Rumbo Marketing. Todos los derechos reservados.
          </p>
          <a
            href="https://readdy.ai/?ref=logo"
            target="_blank"
            rel="noopener noreferrer"
            className="text-white/60 hover:text-accent text-sm transition-colors cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
